module.exports = __webpack_public_path__ + "static/sport/loading.19f6dad.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sport3/loading.gif
// module id = vOM9
// module chunks = 0